package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsDe : Strings {
  override val home: String = "Heim"

  override val about: String = "Um"

  override val contact: String = "Kontakt"

  override val book_stands: String? = null

  override val search: String = "Suchen"

  override val create_library: String = "Bibliothek erstellen"

  override val footer_author: String = "Copyright 2025 dev0029"

  override val section1_title: String = "Verpackung für besondere Tage"

  override val section1_button: String = "Mehr Infos"

  override val section1_desc: String =
      "Für besondere Tage wie Muttertag, Weihnachten oder Valentinstag verpacken wir Ihre Bestellungen sorgfältig."

  override val section2_title: String = "Buchständer fürs Bett"

  override val section2_button: String = "Jetzt bestellen"

  override val section2_desc: String =
      "Suchen Sie nach einem Buchhalter, während Sie im Bett Ihr Lieblingsbuch lesen?"

  override val section3_title: String = "Erstelle eine Miniaturbibliothek"

  override val section3_button: String = "Jetzt erstellen"

  override val section3_desc: String =
      "Was sind deine Lieblingsbücher? Erstelle eine Sammlung deiner Lieblingsbücher und lass uns deine Miniaturbibliothek produzieren!"

  override val shipping_title: String = "Versand"

  override val shipping_desc1: String = "Schneller und kostenloser Versand"

  override val shipping_description: String =
      "Mit unserem Expressversand erreichen Ihre Artikel Ihre Haustür innerhalb von 1-3 Werktagen. Wir versenden in ganz Deutschland."

  override val shipping_description2: String =
      "Darüber hinaus versenden wir in die USA, nach Kanada, Großbritannien und in alle EU-Länder und sorgen so für ein reibungsloses Einkaufserlebnis für alle unsere Kunden."

  override val contact_title: String = "Kontaktieren Sie uns"

  override val contact_email_name: String = "Ihr Name"

  override val contact_email_subject: String = "Thema"

  override val contact_email_message: String = "Nachricht"

  override val contact_email_send_message: String = "Nachricht senden"

  override val library_header_title: String = "Erstellen Sie Ihre Bibliothek"

  override val library_header_title2: String =
      "Ihre Buchliste wurde erstellt, jetzt ist es Zeit, zu bestellen!"

  override val library_header_desc: String = "*Die Reihenfolge der Bücher ist nicht wichtig"

  override val library_header_desc2: String =
      "Klicken Sie auf die Schaltfläche \"Bestellen\" und fügen Sie Ihre eindeutige ID im Abschnitt \"Personalisierung\" bei Etsy ein."

  override val copy_your_id: String = "Kopieren Sie Ihre eindeutige Buchlisten-ID:"

  override val download_book_list: String = "Buchliste herunterladen"

  override val ok: String = "Ok"

  override val remove: String = "Entfernen"

  override val search_author: String = "Autor suchen"

  override val result_found: String = "Ergebnis gefunden"

  override val loading: String = "Laden:"

  override val not_load: String? = null
}
